module.exports = __webpack_public_path__ + "static/media/edit.5fb94440.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ui_icons/edit.svg
// module id = 196
// module chunks = 0